let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5w8u2")).then(() => parcelRequire('hHp0Z'));